// @flow

import CORE_PRODUCT_TYPES from 'client/constants/productTypes';

import type { IfpAppType } from 'web-core/types/ifp-app';

const APP_TYPE_ORDER = [
  CORE_PRODUCT_TYPES.HEALTH,
  CORE_PRODUCT_TYPES.DENTAL,
  CORE_PRODUCT_TYPES.VISION,
];

export const sortAppsByType = (
  apps: Array<IfpAppType>,
  appTypeOrder: Array<string> = APP_TYPE_ORDER,
): Array<IfpAppType> =>
  apps.sort((a, b) => appTypeOrder.indexOf(a.type) - appTypeOrder.indexOf(b.type));
